import React, { useState, useEffect, useContext } from "react";

import {
  WebConfigDataContext,
  ConstraintsContext,
  TransContext,
  FixturesContext,
  CompositionContext,
  PlayerListContext,
  TeamDataContext,
  PlayerDetailTogglerContext,
  TeamListContext,
  PlayerRecommendationContext,
  LoginContext,
  ShowToastContext,
  GamedaysContext,
  ShowPopUpContext,
  PlayerCardContext,
  LiveScoringContext,
  LeaguesContext,
  FetchGamerCardContext,
  GeolocationUrlContext,
  PlayersStatisticsContext,
  BoosterCardContext,
  GamerCardContext,
  MixApiContext,
} from ".";
import {
  getData,
  addPlayer,
  filterList,
  getFilterCount,
  getLocalStorage,
  setLocalStorage,
  getUserProfile,
  searchBy,
  makeCaptain,
  substituteThisPlayer,
  replaceWithThisPlayer,
  cancelSubstitution,
  getAutoSubstitutionsApiData,
  hasTeam,
  getCompositionId,
  getCookie,
  getLoginCookie,
  parseCookie,
  clearLocalStorage,
  logOutCall,
} from "../common";

import config from "../common/config";
import { find, filter } from "lodash";

export const WebConfigDataContextProvider = (props) => {
  let [dynamicCards, setDynamicCardsContent] = useState([]);

  const manupulateDynamicCards = (dynamicCards) => {
    dynamicCards.map((dynamicCard, index) => {
      let cardStatus = getLocalStorage("dynamicCard");
      if (!cardStatus) {
        let cardArray = [];
        if (dynamicCard.isDismissible) {
          let cardObject = {
            persistKey: dynamicCard.persistKey,
            version: dynamicCard.version,
            isDisabled: false,
          };
          cardArray.push(cardObject);
          setLocalStorage("dynamicCard", cardArray);
          dynamicCard.isDisabled = false;
        }
      } else {
        if (dynamicCard.isDismissible) {
          let objIndex = cardStatus.findIndex(
            (card) => card.persistKey === dynamicCard.persistKey
          );
          if (objIndex < 0) {
            let cardObject = {
              persistKey: dynamicCard.persistKey,
              version: dynamicCard.version,
              isDisabled: false,
            };
            cardStatus.push(cardObject);
            setLocalStorage("dynamicCard", cardStatus);
            dynamicCard.isDisabled = false;
          } else {
            if (cardStatus[objIndex].version !== dynamicCard.version) {
              let cardObject = {
                persistKey: dynamicCard.persistKey,
                version: dynamicCard.version,
                isDisabled: false,
              };
              cardStatus[objIndex] = cardObject;
              setLocalStorage("dynamicCard", cardStatus);
              dynamicCard.isDisabled = false;
            } else {
              dynamicCard.isDisabled = false;
            }
          }
        }
      }
    });

    let cardStatus = getLocalStorage("dynamicCard");
    if (cardStatus) {
      cardStatus.forEach((card) => {
        let objIndex = dynamicCards.findIndex(
          (dynamicCard) =>
            card.persistKey === dynamicCard.persistKey &&
            card.version === dynamicCard.version
        );
        dynamicCards[objIndex].isDisabled = card.isDisabled;
      });
    }

    return dynamicCards;
  };

  const getwebConfig = (paramsObj, cb) => {
    let apiParams = {
      endPoint:
        /* config.WebConfigUrl */ config.PUBLIC_API + "/localApis/web.json?v=1",
      type: "GET",
      name: config.APINames.webConfig,
      params: paramsObj,
    };
    getData(apiParams, (resp) => {
      setwebConfig(resp);
      //set dynamic cards
      let dynamicCardsArr = resp.Data.Value.dynamicCard || [];
      let dyamicCardManupulatedArr = manupulateDynamicCards(dynamicCardsArr);
      setDynamicCardsContent(dyamicCardManupulatedArr);
      if (cb) {
        cb(resp.Data.Value);
      }
    });
  };

  const closeDyanamicCard = (dynamiccard, actualData) => {
    let cardStatus = getLocalStorage("dynamicCard");
    if (cardStatus) {
      let objIndex = cardStatus.findIndex(
        (card) =>
          card.persistKey === dynamiccard.persistKey &&
          card.version === dynamiccard.version
      );
      if (objIndex >= 0) {
        cardStatus[objIndex].isDisabled = true;
        setLocalStorage("dynamicCard", cardStatus);
      }

      let dynamicCards = actualData;
      cardStatus.forEach((card) => {
        let objIndex = dynamicCards.findIndex(
          (dynamicCard) =>
            card.persistKey === dynamicCard.persistKey &&
            card.version === dynamicCard.version
        );
        dynamicCards[objIndex].isDisabled = card.isDisabled;
      });
      setDynamicCardsContent([...dynamicCards]);
    } else {
      let emptyArr = [];
      setDynamicCardsContent([...emptyArr]);
    }
  };

  const setwebConfig = (data) => {
    config.WebConfig = data;
    config.FEEDBASEPATH = data.FEED_BASE_URL;
    config.FEEDBASEPATHLIVE = data.FEED_BASE_URL_LIVE;
    config.APIBASEPATH = data.BASE_URL;
    config.playerImgBase = data.playerImageBase;
    config.landingPageImageBase = data.landingpageImagebase;
    config.PS5Obj = data.PS5Obj;
    config.version = data.imgVersion;
  };

  return (
    <WebConfigDataContext.Provider
      value={{
        getwebConfig: getwebConfig,
        setwebConfig: setwebConfig,
        dynamicCards: dynamicCards,
        closeDyanamicCard: closeDyanamicCard,
      }}
    >
      {props.children}
    </WebConfigDataContext.Provider>
  );
};

export const ConstraintsContextProvider = (props) => {
  let [constraints, setConstraints] = useState(null);

  const getConstraints = (paramsObj, cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Constraints]
        ? (config.FEEDBASEPATH + config.WebConfig[config.APINames.Constraints])
            .replace("{{tourId}}", config.tourId)
            .replace("{{lang}}", config.CURRENT_LANGUAGE)
        : config.PUBLIC_API + "/localApis/constraints.json",
      type: "GET",
      name: config.APINames.Constraints,
      params: paramsObj,
    };
    getData(apiParams, (resp) => {
      setConstraints(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
    });
  };

  return (
    <ConstraintsContext.Provider
      value={{
        getConstraints: getConstraints,
        setConstraints: setConstraints,
        data: constraints,
      }}
    >
      {props.children}
    </ConstraintsContext.Provider>
  );
};

export const TransContextProvider = (props) => {
  let [trans, setTrans] = useState(null);
  const getTrans = (paramsObj, cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Trans]
        ? (
            config.FEEDBASEPATH +
            config.WebConfig[config.APINames.Trans].replace(
              "{{lang}}",
              config.language
            )
          ).replace("{{tourId}}", config.tourId)
        : config.FEEDBASEPATH +
          "translations/trans_" +
          config.tourId +
          "_" +
          config.language,
      type: "GET",
      name: config.APINames.Trans,
      params: paramsObj,
    };

    getData(apiParams, (resp) => {
      setTrans(resp && resp.Data && resp.Data.Value);
      if (cb) {
        cb(resp && resp.Data && resp.Data.Value);
      }
    });
  };
  return (
    <TransContext.Provider
      value={{
        data: trans,
        getTrans,
        setTrans,
      }}
    >
      {props.children}
    </TransContext.Provider>
  );
};

export const FixturesContextProvider = (props) => {
  let [fixtures, setFixtures] = useState(null);
  let [showFixPopUpMob, setShowFixPopUpMob] = useState(false);
  let [currMatchDay, setCurrMatchDay] = useState({});
  let [gameMode, setGameMode] = useState(null);
  let [screenMode, setScreenMode] = useState(null);
  let [fixturesMode, setFixturesMode] = useState(null);
  let [fixturesStrip, setFixturesStrip] = useState([]);
  let [defaultMatchDay, setCurrMatchDayDefault] = useState({});
  const getFixtures = (paramsObj, cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.FixturesNew]
        ? (config.FEEDBASEPATH + config.WebConfig[config.APINames.FixturesNew])
            .replace("{{tourId}}", config.tourId)
            .replace("{{lang}}", config.language)
        : config.PUBLIC_API + "/localApis/fixtures.json",
      // endPoint: "/fantasy/feeds/fixtures/fixtures_new_1_en",
      type: "GET",
      name: config.APINames.FixturesNew,
      params: paramsObj,
    };
    getData(apiParams, (resp) => {
      setFixtures(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
    });
  };

  return (
    <FixturesContext.Provider
      value={{
        data: fixtures,
        getFixtures,
        showFixPopUpMob,
        setShowFixPopUpMob,
        currMatchDay,
        setCurrMatchDay,
        setCurrMatchDayDefault,
        defaultMatchDay,
        setGameMode,
        fixturesMode,
        setFixturesMode,
        gameMode,
        screenMode,
        setScreenMode,
        fixturesStrip,
        setFixturesStrip,
      }}
    >
      {props.children}
    </FixturesContext.Provider>
  );
};

export const LeaguesContextProvider = (props) => {
  let [privateLeagues, setPrivateLeagues] = useState(null);
  let [publicLeagues, setPublicLeagues] = useState(null);
  let [publicLeaderboardData, setpublicLeaderboardData] = useState(null);
  let [publicLeaderboardByWeekData, setpublicLeaderboardByWeekData] =
    useState(null);
  let [publicLeaderboardByMonthData, setpublicLeaderboardByMonthData] =
    useState(null);
  let [publicLeaderboardByRoundData, setpublicLeaderboardByRoundData] =
    useState(null);
  let [leaderboardFilterData, setleaderboardFilterData] = useState(null);
  let [privateLeaderboardData, setPrivateLeaderboardData] = useState(null);
  let [publicLeaderboardRankData, setpublicLeaderboardRankData] =
    useState(null);
  let [clubsList, setClubsList] = useState(null);
  let [leagueMembers, setLeagueMembersList] = useState(null);
  let [oUteam, setOUTeam] = useState(null);
  let [oUname, setoUname] = useState(null);
  let [oUcurrGameday, setoUcurrGameday] = useState(null);
  let [isLoading, setIsLoading] = useState(true);
  let [isLoadingLP, setIsLoadingLP] = useState(false);
  const getPrivateLeagues = (paramsObj, cb) => {
    setIsLoadingLP(true);
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.PrivateLeagues]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.PrivateLeagues]
          ).replace("{{guid}}", getUserProfile().GUID)
        : "",
      type: "GET",
      name: config.APINames.PrivateLeagues,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        let RetVal = resp?.Meta?.RetVal;
        if (RetVal === -100) {
          logOutCall();
        } else {
          setPrivateLeagues(resp.Data.Value.UserLeaguesDetail);
          setIsLoadingLP(false);
          if (cb) {
            cb(resp.Data.Value);
          }
        }
      },
      (error) => {
        let RetVal = error?.RetVal;
        if (RetVal === -100) {
          logOutCall();
        }
      }
    );
  };

  const getPublicLeagues = (paramsObj, cb) => {
    setIsLoadingLP(true);
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.PublicLeagues]
        ? (
            config.APIBASEPATH + config.WebConfig[config.APINames.PublicLeagues]
          ).replace("{{guid}}", getUserProfile().GUID)
        : "",
      type: "GET",
      name: config.APINames.PublicLeagues,
      params: paramsObj,
    };
    getData(apiParams, (resp) => {
      setPublicLeagues(resp.Data.Value);
      // setIsLoading(false);
      setIsLoadingLP(false);
      if (cb) {
        cb(resp.Data.Value);
      }
    });
  };

  const createLeague = (paramsObj, cb, error) => {
    let apiParams = {
      // endPoint: config.webConfig[config.APINames.CreateLeague]
      //   ? (
      //     config.APIBASEPATH + config.webConfig[config.APINames.CreateLeague]
      //   ).replace("{{guid}}", paramsObj.guid ? paramsObj.guid : "")
      //   : "",
      endPoint: config.WebConfig[config.APINames.CreateLeague]
        ? (config.APIBASEPATH + config.WebConfig[config.APINames.CreateLeague])
            .replace("{{guid}}", paramsObj.guid ? paramsObj.guid : "")
            .replace("{{lang}}", config.CURRENT_LANGUAGE)
        : "",
      type: "POST",
      name: config.APINames.CreateLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        // console.log(resp);
        if (cb) {
          cb(resp.Data.Value);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const relaunchLeague = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.RelaunchLeague]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.RelaunchLeague]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.RelaunchLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value, resp);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const joinLeague = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.JoinLeague]
        ? (config.APIBASEPATH + config.WebConfig[config.APINames.JoinLeague])
            .replace("{{guid}}", getUserProfile().GUID)
            .replace("{{lang}}", config.CURRENT_LANGUAGE)
        : "",
      type: "POST",
      name: config.APINames.JoinLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };
  const reJoinLeague = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.RejoinLeague]
        ? (
            config.APIBASEPATH + config.WebConfig[config.APINames.RejoinLeague]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.RejoinLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };
  const getPublicLeagueLeaderBoardData = (paramsObj, endpoint, cb) => {
    let TypeID = paramsObj.TypeID;
    let apiName =
      TypeID == 1
        ? config.APINames.publicLeaderBoardGlobal
        : TypeID == 2
        ? config.APINames.publicLeaderBoardCountry
        : config.APINames.publicLeaderBoardClub;
    delete paramsObj.TypeID;
    let apiParams = {
      endPoint: (config.FEEDBASEPATH + endpoint).replace(
        "{{TourId}}",
        config.tourId
      ),
      type: "GET",
      name: apiName,
      params: paramsObj,
    };
    // setIsLoading(true);
    getData(apiParams, (resp) => {
      console.log(resp);
      setpublicLeaderboardData(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
      // setIsLoading(false);
    });
  };

  const getLeaderBoardByWeekData = (paramsObj, endpoint, cb) => {
    let TypeID = paramsObj.TypeID;
    let apiName =
      TypeID == 1
        ? config.APINames.publicLeaderBoardByWeekGlobal
        : TypeID == 2
        ? config.APINames.publicLeaderBoardByWeekCountry
        : config.APINames.publicLeaderBoardByWeekClub;
    delete paramsObj.TypeID;
    let apiParams = {
      endPoint: (config.FEEDBASEPATH + endpoint).replace(
        "{{TourId}}",
        config.tourId
      ),
      type: "GET",
      name: apiName,
      params: paramsObj,
    };
    // setIsLoading(true);
    getData(apiParams, (resp) => {
      console.log(resp);
      setpublicLeaderboardByWeekData(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
      // setIsLoading(false);
    });
  };

  const getLeaderBoardByMonthData = (paramsObj, endpoint, cb) => {
    let TypeID = paramsObj.TypeID;
    let apiName =
      TypeID == 1
        ? config.APINames.publicLeaderBoardByMonthGlobal
        : TypeID == 2
        ? config.APINames.publicLeaderBoardByMonthCountry
        : config.APINames.publicLeaderBoardByMonthClub;
    delete paramsObj.TypeID;
    let apiParams = {
      endPoint: (config.FEEDBASEPATH + endpoint).replace(
        "{{TourId}}",
        config.tourId
      ),
      type: "GET",
      name: apiName,
      params: paramsObj,
    };
    // setIsLoading(true);
    getData(apiParams, (resp) => {
      console.log(resp);
      setpublicLeaderboardByMonthData(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
      // setIsLoading(false);
    });
  };

  const getLeaderBoardByRoundData = (paramsObj, endpoint, cb) => {
    let TypeID = paramsObj.TypeID;
    let apiName =
      TypeID == 1
        ? config.APINames.publicLeaderBoardByRoundGlobal
        : TypeID == 2
        ? config.APINames.publicLeaderBoardByRoundCountry
        : config.APINames.publicLeaderBoardByRoundClub;
    delete paramsObj.TypeID;
    let apiParams = {
      endPoint: (config.FEEDBASEPATH + endpoint).replace(
        "{{TourId}}",
        config.tourId
      ),
      type: "GET",
      name: apiName,
      params: paramsObj,
    };
    // setIsLoading(true);
    getData(apiParams, (resp) => {
      console.log(resp);
      setpublicLeaderboardByRoundData(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
      // setIsLoading(false);
    });
  };

  const getLeaderBoardFilterData = (paramsObj, cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.leaderboardFilter]
        ? (
            config.FEEDBASEPATH +
            config.WebConfig[config.APINames.leaderboardFilter]
          )
            .replace("{{TourId}}", config.tourId)
            .replace("{{lang}}", config.CURRENT_LANGUAGE)
        : "",
      type: "GET",
      name: config.APINames.leaderboardFilter,
      params: paramsObj,
    };
    // setIsLoading(true);
    getData(apiParams, (resp) => {
      console.log(resp);
      setleaderboardFilterData(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
      // setIsLoading(false);
    });
  };

  const getPrivateLeaderboardData = (paramsObj, cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.privateLeaderboard]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.privateLeaderboard]
          ).replace("{{guid}}", getUserProfile().GUID)
        : "",
      type: "GET",
      name: config.APINames.privateLeaderboard,
      params: paramsObj,
    };
    // setIsLoading(true);
    getData(apiParams, (resp) => {
      setPrivateLeaderboardData(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
      // setIsLoading(false);
    });
  };

  const onDeletePreviousLeagueClick = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.onDeletePreviousLeague]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.onDeletePreviousLeague]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.onDeletePreviousLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value, resp);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const onDeletePreviousMembersLeagueClick = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.onDeletePreviousMembersLeague]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.onDeletePreviousMembersLeague]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.onDeletePreviousMembersLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const getPublicLeagueLeaderBoardRankData = (paramsObj, cb) => {
    let TypeID = paramsObj.TypeID;
    let apiName =
      TypeID == 1
        ? config.APINames.publicLeaderBoardGlobal
        : TypeID == 2
        ? config.APINames.publicLeaderBoardCountry
        : config.APINames.publicLeaderBoardClub;
    delete paramsObj.TypeID;
    let rankEndpt = paramsObj.rankEndpoint;
    delete paramsObj.rankEndpoint;
    let apiParams = {
      endPoint: config.APIBASEPATH + rankEndpt,
      type: "GET",
      name: apiName,
      params: paramsObj,
    };
    // setIsLoading(true);
    getData(apiParams, (resp) => {
      setpublicLeaderboardRankData(resp.Data.Value);
      // setIsLoading(false);
      if (cb) {
        cb(resp.Data.Value);
      }
    });
  };

  const fetchClubs = (paramsObj, cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.fetchClubs]
        ? config.FEEDBASEPATH + config.WebConfig[config.APINames.fetchClubs]
        : "",
      type: "GET",
      name: config.APINames.fetchClubs,
      params: paramsObj,
    };
    getData(apiParams, (resp) => {
      setClubsList(resp.value);
      if (cb) {
        cb(resp.value);
      }
    });
  };

  const updateFavouriteTeam = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.updateFavouriteTeam]
        ? config.APIBASEPATH +
          config.WebConfig[config.APINames.updateFavouriteTeam]
        : "",
      type: "POST",
      name: config.APINames.updateFavouriteTeam,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const getLeagueMembersData = (paramsObj, cb) => {
    let lgId = paramsObj.lgId;
    delete paramsObj.lgId;
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.leagueMembers]
        ? //  (
          //   config.APIBASEPATH + config.WebConfig[config.APINames.leagueMembers]
          // ).replace("{{leagueid}}", paramsObj.leagueID)
          (
            config.APIBASEPATH + config.WebConfig[config.APINames.leagueMembers]
          ).replace("{{leagueid}}", lgId)
        : "",
      type: "GET",
      name: config.APINames.leagueMembers,
      params: paramsObj,
    };
    // setIsLoading(true);
    getData(apiParams, (resp) => {
      setLeagueMembersList(resp.Data.Value);
      if (cb) {
        cb(resp.Data.Value);
      }
      // setIsLoading(false);
    });
  };

  const suspendLeague = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.postSuspendLeague]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.postSuspendLeague]
          ).replace("{{guid}}", getUserProfile().GUID)
        : "",
      type: "POST",
      name: config.APINames.postSuspendLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.Meta);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const removeLeagueSuspension = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.postRemoveSuspensionLeague]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.postRemoveSuspensionLeague]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.postRemoveSuspensionLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.Meta);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const deleteLeague = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.postDeleteLeague]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.postDeleteLeague]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.postDeleteLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.Meta);
        }
      },
      (resp) => {
        error(resp.Meta);
      }
    );
  };

  const leaveLeague = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.postLeaveLeague]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.postLeaveLeague]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.postLeaveLeague,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.Meta);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const updateLeagueNamePost = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.updateLeagueName]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.updateLeagueName]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.updateLeagueName,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const updateLeagueCodeLinkAchievement = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[
        config.APINames.updateLeagueCodeLinkAchievementUrl
      ]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.updateLeagueCodeLinkAchievementUrl]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.updateLeagueCodeLinkAchievementUrl,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  // other users teams functions
  const getOUGamedays = (paramsObj, cb, er) => {
    let guid = paramsObj.userguid;
    delete paramsObj.userguid;
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.OtherUsrGamedays]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.OtherUsrGamedays]
          ).replace("{{guid}}", guid)
        : "",
      type: "GET",
      name: config.APINames.OtherUsrGamedays,
      params: paramsObj,
    };

    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.Data.Value);
        }
      },
      (resp) => {
        if (er) {
          er(resp);
        }
      }
    );
  };

  const getOUTeam = (paramsObj, cb, er) => {
    let guid = paramsObj.userguid;
    delete paramsObj.userguid;
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.OtherUsrTeam]
        ? (
            config.APIBASEPATH + config.WebConfig[config.APINames.OtherUsrTeam]
          ).replace("{{guid}}", guid)
        : "",
      type: "GET",
      name: config.APINames.OtherUsrTeam,
      params: paramsObj,
    };

    getData(
      apiParams,
      (resp) => {
        // setOUTeam(resp.Data.Value);
        if (cb) {
          cb(resp.Data.Value);
        }
      },
      (resp) => {
        if (er) {
          er(resp);
        }
      }
    );
  };

  //end

  return (
    <LeaguesContext.Provider
      value={{
        privateLeagues,
        publicLeagues,
        publicLeaderboardData,
        publicLeaderboardByWeekData,
        publicLeaderboardByMonthData,
        publicLeaderboardByRoundData,
        leaderboardFilterData,
        publicLeaderboardRankData,
        privateLeaderboardData,
        clubsList,
        leagueMembers,
        getPrivateLeagues,
        getPublicLeagues,
        createLeague,
        relaunchLeague,
        joinLeague,
        reJoinLeague,
        onDeletePreviousLeagueClick,
        onDeletePreviousMembersLeagueClick,
        getPublicLeagueLeaderBoardData,
        getLeaderBoardByWeekData,
        getLeaderBoardByMonthData,
        getLeaderBoardByRoundData,
        getLeaderBoardFilterData,
        getPublicLeagueLeaderBoardRankData,
        getPrivateLeaderboardData,
        fetchClubs,
        updateFavouriteTeam,
        getLeagueMembersData,
        suspendLeague,
        removeLeagueSuspension,
        deleteLeague,
        leaveLeague,
        updateLeagueNamePost,
        updateLeagueCodeLinkAchievement,
        getOUGamedays,
        getOUTeam,
        oUteam,
        oUcurrGameday,
        setoUcurrGameday,
        setOUTeam,
        oUname,
        setoUname,
        setIsLoading,
        isLoading,
        setIsLoadingLP,
        isLoadingLP,
      }}
    >
      {props.children}
    </LeaguesContext.Provider>
  );
};
export const BoosterCardContextProvider = (props) => {
  let [objShowHideBooster, setObjShowHideBooster] = useState(null);
  let [isTempLimitlessBooster, setTempLimitlessBooster] = useState(null);
  let loginCookie = getLoginCookie();
  const submitBooster = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Booster]
        ? config.APIBASEPATH +
          config.WebConfig[config.APINames.Booster].replace(
            "{{guid}}",
            loginCookie.GUID
          )
        : (config.APIBASEPATH + "gameplay/user/{{guid}}/booster").replace(
            "{{guid}}",
            loginCookie.GUID
          ),
      type: "POST",
      name: "Boosters",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const submitLimitlessBooster = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.LimitlessBooster]
        ? config.APIBASEPATH +
          config.WebConfig[config.APINames.LimitlessBooster].replace(
            "{{guid}}",
            loginCookie.GUID
          )
        : (
            config.APIBASEPATH + "gameplay/user/{{guid}}/limitlessbooster"
          ).replace("{{guid}}", loginCookie.GUID),
      type: "POST",
      name: "Limitless Boosters",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const removeBooster = (paramsObj, cb, err) => {
    let loginCookie = getLoginCookie();
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.RemoveBooster]
        ? config.APIBASEPATH +
          config.WebConfig[config.APINames.RemoveBooster].replace(
            "{{guid}}",
            loginCookie.GUID
          )
        : (config.APIBASEPATH + "gameplay/user/{{guid}}/removebooster").replace(
            "{{guid}}",
            loginCookie.GUID
          ),
      type: "POST",
      name: "Remove Boosters",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  return (
    <BoosterCardContext.Provider
      value={{
        objShowHideBooster,
        setObjShowHideBooster,
        submitBooster,
        submitLimitlessBooster,
        removeBooster,
        setTempLimitlessBooster,
        isTempLimitlessBooster,
      }}
    >
      {props.children}
    </BoosterCardContext.Provider>
  );
};

export const CompositionContextProvider = (props) => {
  let [compositions, setCompositions] = useState(null);
  let [activeComposition, setActiveComposition] = useState(null);
  let [isCompositionPopUpVisible, setVisisble] = useState(false);
  let [countriesList, setCountriesList] = useState(null);
  let [boostersList, setBoostersList] = useState(null);
  let [teamList, setTeamList] = useState(null);
  let [rawList, setRawlist] = useState(null);
  let [searchString, setSearchString] = useState("");
  const setFormationPopUpVisiblity = (isVisible) => {
    setVisisble(isVisible);
  };

  const getComposition = (paramsObj, cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Compositions]
        ? (config.FEEDBASEPATH + config.WebConfig[config.APINames.Compositions])
            .replace("{{tourId}}", config.tourId)
            .replace("{{lang}}", config.language)
        : config.PUBLIC_API + "/localApis/formations.json",
      type: "GET",
      name: config.APINames.Compositions,
      params: paramsObj,
    };

    getData(apiParams, (resp) => {
      setCompositions(resp.Data.Value.composition);
      setCountriesList(resp.Data.Value.countries);
      setBoostersList(resp.Data.Value.boosters);
      let formationsData = [];

      for (let [key, value] of Object.entries(resp.Data.Value.composition)) {
        formationsData.push(value);
      }
      let defaultComp = {};

      if (getLocalStorage("lastFormation").length) {
        defaultComp = getLocalStorage("lastFormation");
      } else {
        defaultComp = find(formationsData, function (o) {
          return o.IsDefault;
        });
      }

      if (getLocalStorage("teamData")) {
        let prevTeamData = getLocalStorage("teamData");
        let prevComposition = getCompositionId(prevTeamData, formationsData);
        defaultComp = prevComposition.length ? prevComposition : defaultComp;
      }

      setActiveComposition(defaultComp);
      setLocalStorage("lastFormation", defaultComp);
      setRawlist(resp.Data.Value.teams);
      setTeamList(resp.Data.Value.teams);
      if (cb) {
        cb(resp.Data.Value);
      }
    });
  };
  const setTeamFilter = () => {
    const searchByTeamName = rawList.filter((teamName) => {
      return searchString
        ? searchBy(teamName, ["WebName"], searchString)
        : true;
    });
    setTeamList(searchByTeamName);
  };

  const resetSearchString = () => {
    setSearchString("");
    setTeamList(rawList);
  };

  return (
    <CompositionContext.Provider
      value={{
        data: compositions,
        TeamListContextData: teamList,
        getComposition,
        activeComposition,
        setActiveComposition,
        isCompositionPopUpVisible,
        setFormationPopUpVisiblity,
        setCompositions,
        resetSearchString,
        setSearchString,
        setTeamFilter,
        searchString,
        countriesList,
        setCountriesList,
        boostersList,
        setBoostersList,
      }}
    >
      {props.children}
    </CompositionContext.Provider>
  );
};

export const PlayerListContextProvider = (props) => {
  let [rawPlayerList, setRawPlayerList] = useState(null); //alll palers with isActive 0 also
  let [playerList, setPlayerList] = useState(null); //all palyer with active 1 and used for display
  let [filteredPlayerrawList, setfilteredPlayer] = useState(null); //all palyer with active 1 and used for filter
  let [PlayerListCalledFlag, setPlayerListCalledFlag] = useState(false);
  let [filterCount, setFilterCount] = useState(0);
  let [isPlayerListVisible, setPlayerListVisible] = useState(false);
  let [isMobileFiltersVisible, setMobileFiltersVisible] = useState(false);
  let [playerListFilters, setPlayerListFilters] = useState(
    config.playerFilters
  );
  let [showLateOnBoarding, setLateOnboarding] = useState(false);
  let [lateOnBoardingPlayers, setLateOnboardingPlys] = useState([]);

  const togglePlayerList = (isVisible, callback) => {
    if (isPlayerListVisible == false) {
      setLocalStorage("showDialogue", false);
    }
    setPlayerListVisible(isVisible);

    if (callback) {
      callback();
    }
  };

  const setMobileFiltersFlag = (isVisible = !isMobileFiltersVisible) => {
    setMobileFiltersVisible(isVisible);
  };

  const setPlayerFilters = (filters, budget) => {
    //sort player list and set set Player list
    //get count
    let filtercount = getFilterCount(filters);

    setFilterCount(filtercount);
    filters.filterCount = filtercount;
    setPlayerListFilters(filters);
    if (
      budget != null &&
      budget != undefined &&
      filteredPlayerrawList &&
      filteredPlayerrawList.playerList
    ) {
      let filteredResponse = filterList(
        filteredPlayerrawList.playerList,
        filters,
        budget
      );
      setPlayerList({ playerList: filteredResponse });
    }
  };

  const setIsactivePlayerList = (playerlist) => {
    let breakRefPlayerList = JSON.parse(JSON.stringify(playerlist));
    let activePlayer = {
      playerList: [],
    };
    activePlayer.playerList = filter(breakRefPlayerList, function (o) {
      return o.IsActive;
    });
    setPlayerList(activePlayer);
    setfilteredPlayer(activePlayer);
  };

  const getPlayerList = (paramsObj, cb) => {
    let gamedayId = paramsObj.gamedayId;
    delete paramsObj.gamedayId;
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Player]
        ? (config.FEEDBASEPATH + config.WebConfig[config.APINames.Player])
            .replace("{{tourId}}", config.tourId)
            .replace("{{gamedayId}}", gamedayId)
            .replace("{{lang}}", config.language)
        : config.PUBLIC_API + "/localApis/players.json",
      type: "GET",
      name: config.APINames.Player,
      params: paramsObj,
    };
    setLocalStorage("mdForPlayerList", paramsObj.matchdayId);
    getData(apiParams, (resp) => {
      setRawPlayerList(resp.Data.Value.Players);

      setIsactivePlayerList(resp.Data.Value.Players);

      setPlayerListCalledFlag(true);

      if (cb) {
        cb(resp.Data.Value.Players);
      }
    });
  };

  return (
    <PlayerListContext.Provider
      value={{
        data: playerList,
        getPlayerList,
        togglePlayerList,
        isPlayerListVisible,
        isMobileFiltersVisible,
        playerListFilters: playerListFilters,
        setPlayerFilters: setPlayerFilters,
        PlayerListCalledFlag: PlayerListCalledFlag,
        filterCount: filterCount,
        setMobileFiltersFlag,
        rawPlayerList,
        showLateOnBoarding,
        setLateOnboarding,
        lateOnBoardingPlayers,
        setLateOnboardingPlys,
      }}
    >
      {props.children}
    </PlayerListContext.Provider>
  );
};

export const TeamDataContextProvider = (props) => {
  let loginCookie = getLoginCookie();
  let lastTeam = getLocalStorage("teamData");
  if (lastTeam) {
    //update last team with updated players

    teamData = lastTeam;
  } else {
    lastTeam = null;
  }
  let [teamData, setTeamData] = useState(hasTeam() ? null : lastTeam);
  let [errorObj, setErroObj] = useState(null);
  let [manageTeamRawData, setManageTeamRawData] = useState({});
  let [playerTobeRemoved, setPlayerTobeRemoved] = useState({});
  let [prevTeamData, setPrevTeamdata] = useState(lastTeam);
  let [liveTeamData, setLiveTeamData] = useState(null);
  let tutorialFlag = false;
  if (
    getLocalStorage("setHasSeenTutorial") == null ||
    getLocalStorage("setHasSeenTutorial") == undefined ||
    getLocalStorage("setHasSeenTutorial") == ""
  ) {
    setLocalStorage("setHasSeenTutorial", false);
    tutorialFlag = false;
  } else {
    tutorialFlag = getLocalStorage("setHasSeenTutorial");
  }
  if (lastTeam) {
    setLocalStorage("setHasSeenTutorial", true);
    tutorialFlag = true;
  }

  let [hasSeenTutorial, setHasSeenTutorial] = useState(tutorialFlag);

  let manageTutorialFlag = false;
  if (
    getLocalStorage("setHasSeenManageTutorial") == null ||
    getLocalStorage("setHasSeenManageTutorial") == undefined ||
    getLocalStorage("setHasSeenManageTutorial") == ""
  ) {
    manageTutorialFlag = false;
  } else {
    manageTutorialFlag = getLocalStorage("setHasSeenManageTutorial");
  }

  let [hasSeenManageTutorial, setHasSeenManageTutorial] =
    useState(manageTutorialFlag);

  let SubsTutorialFlag = false;
  if (
    getLocalStorage("setHasSeenSubsTutorial") == null ||
    getLocalStorage("setHasSeenSubsTutorial") == undefined ||
    getLocalStorage("setHasSeenSubsTutorial") == ""
  ) {
    SubsTutorialFlag = false;
  } else {
    SubsTutorialFlag = getLocalStorage("setHasSeenSubsTutorial");
  }

  let [hasSeenSubsTutorial, setHasSeenSubsTutorial] =
    useState(SubsTutorialFlag);

  const addRemovePlayer = (playerObj, manageTeamRawData = {}, position) => {
    let rowIndex = playerObj.BenchPosition ? 0 : playerObj.Skill;
    let positionIndex = position ? position : undefined;
    console.log(config.playerFilters.skillId);
    let addRemoveResp = addPlayer(
      teamData,
      playerObj,
      playerObj.Skill,
      rowIndex,
      positionIndex,
      manageTeamRawData,
      config.playerFilters.skillId,
      false
    );
    if (addRemoveResp.errorObj) {
      if (
        addRemoveResp.errorObj.playersPerSkillCountExceeded ||
        addRemoveResp.errorObj.playersPerTeamCountExceeded
      ) {
        if (
          addRemoveResp.errorObj.state == "ok" ||
          addRemoveResp.errorObj.state == "level"
        ) {
          setTeamData(
            addRemoveResp.teamData
              ? addRemoveResp.teamData
              : addRemoveResp.teamDataT
          );
        } else {
          setErroObj(addRemoveResp.errorObj);
        }
      } else {
        setTeamData(
          addRemoveResp.teamData
            ? addRemoveResp.teamData
            : addRemoveResp.teamDataT
        );
      }
    }
    setLocalStorage(
      "teamData",
      addRemoveResp.teamData ? addRemoveResp.teamData : addRemoveResp.teamDataT
    );
  };

  const makePlayerCaptain = (teamData, objKey, playerIndex, player) => {
    let makeCaptainResp = makeCaptain(teamData, objKey, playerIndex, player);
    setTeamData(makeCaptainResp);
  };

  const makePostTeam = (paramsObj, cb, error) => {
    let loginCookie = getLoginCookie();
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.PostTeam]
        ? (
            config.APIBASEPATH + config.WebConfig[config.APINames.PostTeam]
          ).replace("{{guid}}", loginCookie.GUID)
        : "",
      type: "POST",
      name: config.APINames.PostTeam,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const makePostTeamTransfers = (paramsObj, cb, error) => {
    let apicall = config.APINames.postTransfer;
    let apiParams = {
      endPoint: config.WebConfig[apicall]
        ? (config.APIBASEPATH + config.WebConfig[apicall]).replace(
            "{{guid}}",
            loginCookie.GUID
          )
        : "",
      type: "POST",
      name: apicall,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const makePostCaptain = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.captain]
        ? (
            config.APIBASEPATH + config.WebConfig[config.APINames.captain]
          ).replace("{{guid}}", loginCookie.GUID)
        : "",
      type: "POST",
      name: config.APINames.captain,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp);
        }
      },
      (resp) => {
        if (error) {
          error(resp);
        }
      }
    );
  };

  const initiateSubstitution = (teamData, player) => {
    setTeamData(substituteThisPlayer(teamData, player));
  };

  const makeSubstitution = (player, formations) => {
    let replacedTeam = replaceWithThisPlayer(
      teamData,
      manageTeamRawData,
      player
    );
    const fwd = replacedTeam["4"].length;
    const mid = replacedTeam["3"].length;
    const def = replacedTeam["2"].length;
    const defaultFormation = find(formations, {
      DEF: def,
      MID: mid,
      FWD: fwd,
    });
    const defaultFormationIndex = defaultFormation.CompId;
    replacedTeam.CompId = defaultFormationIndex;
    setTeamData(replacedTeam);
  };

  const cancelSubs = () => {
    setTeamData(cancelSubstitution(prevTeamData));
  };

  const autoSubs = (teamData, rawTeamData) => {
    let newSubsTeamData = getAutoSubstitutionsApiData(teamData, rawTeamData);
    setTeamData(newSubsTeamData);
  };

  const makeSubsPostcall = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.subs]
        ? (config.APIBASEPATH + config.WebConfig[config.APINames.subs]).replace(
            "{{guid}}",
            loginCookie.GUID
          )
        : "",
      type: "POST",
      name: config.APINames.subs,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const updateBoosterStatus = (key, value) => {
    teamData[key] = value;
    setTeamData(teamData);
  };

  const makeProfanitycheck = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.profanityTeamName]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.profanityTeamName]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.profanityTeamName,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  const teamNameUpdate = (paramsObj, cb, error) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.teamnameUpdate]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.teamnameUpdate]
          ).replace("{{guid}}", paramsObj.guid)
        : "",
      type: "POST",
      name: config.APINames.teamnameUpdate,
      params: paramsObj.teamName,
    };
    getData(
      apiParams,
      (resp) => {
        if (cb) {
          cb(resp.value);
        }
      },
      (resp) => {
        error(resp);
      }
    );
  };

  return (
    <TeamDataContext.Provider
      value={{
        data: teamData,
        errorObj: errorObj,
        setTeamData,
        addRemovePlayer,
        makePlayerCaptain,
        setManageTeamRawData,
        manageTeamRawData,
        setPrevTeamdata,
        prevTeamData,
        setErroObj,
        makePostTeam,
        makePostTeamTransfers,
        makePostCaptain,
        playerTobeRemoved,
        setPlayerTobeRemoved,
        initiateSubstitution,
        makeSubstitution,
        cancelSubs,
        makeSubsPostcall,
        autoSubs,
        liveTeamData,
        setLiveTeamData,
        updateBoosterStatus,
        hasSeenTutorial,
        setHasSeenTutorial,
        hasSeenManageTutorial,
        setHasSeenManageTutorial,
        hasSeenSubsTutorial,
        setHasSeenSubsTutorial,
        makeProfanitycheck,
        teamNameUpdate,
      }}
    >
      {props.children}
    </TeamDataContext.Provider>
  );
};

export const PlayerDetailTogglerProvider = (props) => {
  let [value, setToggler] = useState(0);

  const changeView = (value) => {
    setToggler(value);
  };
  return (
    <PlayerDetailTogglerContext.Provider
      value={{
        changeView: changeView,
        value: value,
      }}
    >
      {props.children}
    </PlayerDetailTogglerContext.Provider>
  );
};

let callBack = "";

export const PlayerRecomendationContextProvider = (props) => {
  let [recommendation, setRecommendation] = useState(null);
  let [firstTimeUser, setFirstTimeUserFlag] = useState(null);
  let [showRecomPopUp, setShowRecomPopUp] = useState(false);
  let [showIndependantPopUp, setShowIndependantPopUp] = useState(false);

  const setShowRecomPopUpFunc = (value, cb) => {
    setShowRecomPopUp(value);
    if (cb) {
      callBack = cb;
    }
    if (value == false && callBack) {
      callBack();
    }
  };

  const setFirstTimeUser = (flag) => {
    if (flag) {
      localStorage.setItem("isPlayerRecomendationFirst", "true");
      setFirstTimeUserFlag(flag);
    } else {
      localStorage.setItem("isPlayerRecomendationFirst", "false");
      setFirstTimeUserFlag(flag);
    }
  };

  const getPlayerRecomendation = (paramsObj, cb) => {
    let getRecomendation = localStorage.getItem("isPlayerRecomendationFirst");
    if (getRecomendation == null) {
      setFirstTimeUser(true);
    } else {
      if (getRecomendation == "false") {
        setFirstTimeUser(false);
      } else {
        setFirstTimeUser(true);
      }
    }

    let isActiveCategories = config.WebConfig.recomendation.map(function (obj) {
      return obj.isActive == 1 ? obj : null;
    });
    setRecommendation(isActiveCategories);
    if (cb) {
      cb(isActiveCategories);
    }
    // });
  };

  return (
    <PlayerRecommendationContext.Provider
      value={{
        data: recommendation,
        getPlayerRecomendation,
        firstTimeUser: firstTimeUser,
        setFirstTimeUser: setFirstTimeUser,
        showRecomPopUp: showRecomPopUp,
        setShowRecomPopUp: setShowRecomPopUpFunc,
        showIndependantPopUp: showIndependantPopUp,
        setShowIndependantPopUp: setShowIndependantPopUp,
      }}
    >
      {props.children}
    </PlayerRecommendationContext.Provider>
  );
};

export const LoginContextProvider = (props) => {
  let [loginData, setLoginData] = useState(null);
  let [userData, setUserData] = useState(null);
  let [isUserLoggedIn, setUserloginSts] = useState(null);
  let [objShowHideLogin, setObjShowHideLogin] = useState();
  let [isShowLoginPopup, setIsShowLoginPopup] = useState(false);
  let [userProfile, setUserProfile] = useState(null);

  const makeSocialLogin = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.SocialLogin]
        ? config.LOGINAPIBASEPATH +
          config.WebConfig[config.APINames.SocialLogin]
        : config.BASE_DOMAIN + config.LOGINAPIBASEPATH + "socialloginwootp",
      type: "POST",
      name: "Social Login",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        setLoginData(resp.Data);
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const makeLogoutCall = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Logout]
        ? config.LOGINAPIBASEPATH + config.WebConfig[config.APINames.Logout]
        : config.LOGINAPIBASEPATH + "logout",
      type: "POST",
      name: "Logout",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        clearLocalStorage();
        paramsObj.isReload && window.location.reload();
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const submitMobileNo = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.SubmitMobile]
        ? config.LOGINAPIBASEPATH +
          config.WebConfig[config.APINames.SubmitMobile]
        : config.BASE_DOMAIN + config.LOGINAPIBASEPATH + "otp",
      type: "POST",
      name: "OTP Generation",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        setLoginData(resp.Data);
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const connectingSocialLogin = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.ConnectingSocialLogin]
        ? config.LOGINAPIBASEPATH +
          config.WebConfig[config.APINames.ConnectingSocialLogin]
        : config.BASE_DOMAIN + config.LOGINAPIBASEPATH + "connectingsocial",
      type: "POST",
      name: "Social Login",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        setLoginData(resp.Data);
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const submitEmail = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.SubmitEmail]
        ? config.LOGINAPIBASEPATH +
          config.WebConfig[config.APINames.SubmitEmail]
        : config.BASE_DOMAIN + config.LOGINAPIBASEPATH + "connectingcustom",
      type: "POST",
      name: "OTP Generation",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        setLoginData(resp.Data);
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const registerUser = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Registration]
        ? config.LOGINAPIBASEPATH +
          config.WebConfig[config.APINames.Registration]
        : config.BASE_DOMAIN +
          config.LOGINAPIBASEPATH +
          "loginregistrationwootp",
      type: "POST",
      name: "Registration",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        setLoginData(resp.Data);
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const makeCustomLogin = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.CustomLogin]
        ? config.LOGINAPIBASEPATH +
          config.WebConfig[config.APINames.CustomLogin]
        : config.BASE_DOMAIN + config.LOGINAPIBASEPATH + "customlogin",
      type: "POST",
      name: "CustomLogin",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        setLoginData(resp.Data);
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const makeCustomEmailLogin = (paramsObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.CustomEmailLogin]
        ? config.LOGINAPIBASEPATH +
          config.WebConfig[config.APINames.CustomEmailLogin]
        : config.BASE_DOMAIN + config.LOGINAPIBASEPATH + "emaillogin",
      type: "POST",
      name: "CustomLogin",
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        setLoginData(resp.Data);
        if (cb) {
          cb(resp.Data);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };
  const getUserProfileData = (parmObj, cb) => {
    let loginCookie = getLoginCookie();
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.UserProfile]
        ? config.LOGINAPIBASEPATH +
          config.WebConfig[config.APINames.UserProfile].replace(
            "{{guid}}",
            loginCookie.GUID
          )
        : (config.LOGINAPIBASEPATH + "{{guid}}/profile").replace(
            "{{guid}}",
            loginCookie.GUID
          ),
      type: "GET",
      name: "User Data",
      params: parmObj,
    };
    getData(
      apiParams,
      (resp) => {
        let RetVal = resp?.Meta?.RetVal;
        if (RetVal === -100) {
          logOutCall();
        } else {
          setUserProfile(resp.Data.Value);
          if (cb) {
            cb(resp.Data.Value);
          }
        }
      },
      (error) => {
        let RetVal = error?.RetVal;
        if (RetVal === -100) {
          logOutCall();
        }
      }
    );
  };

  return (
    <LoginContext.Provider
      value={{
        data: loginData,
        isUserLoggedIn,
        setUserloginSts,
        setLoginData,
        setObjShowHideLogin,
        objShowHideLogin,
        makeSocialLogin,
        submitMobileNo,
        setIsShowLoginPopup,
        makeLogoutCall,
        userData,
        setUserData,
        isShowLoginPopup,
        registerUser,
        submitEmail,
        connectingSocialLogin,
        makeCustomLogin,
        makeCustomEmailLogin,
        getUserProfileData,
        userProfile,
      }}
    >
      {props.children}
    </LoginContext.Provider>
  );
};

export const ShowToastProvider = (props) => {
  let [messageObj, setMessage] = useState({});
  const setToastMessageObj = (msg, callback) => {
    msg.callBack = callback;
    setMessage(msg);

    if (msg.showMsg == false) {
      if (messageObj.callBack) {
        messageObj.callBack();
      }
    }
  };

  return (
    <ShowToastContext.Provider
      value={{
        data: messageObj,
        setToastMessageObj,
      }}
    >
      {props.children}
    </ShowToastContext.Provider>
  );
};

export const ShowPopUpProvider = (props) => {
  let [messageObj, setMessage] = useState({});

  const setToastMessageObj = (msg, callback) => {
    msg.callBack = callback;
    setMessage(msg);
  };

  return (
    <ShowPopUpContext.Provider
      value={{
        data: messageObj,
        setToastMessageObj,
      }}
    >
      {props.children}
    </ShowPopUpContext.Provider>
  );
};

export const GamedaysProvider = (props) => {
  let [gamedays, setGamedays] = useState(null);
  let [getTeamCalled, setTeamCalled] = useState(false);
  let [selectedTeam, setSelectedTeam] = useState(null);
  let [currGameday, setCurrGameday] = useState(null);

  let [isGamedaysCalled, setIsGamedaysCalled] = useState(false);
  let [isTeamLoading, setIsTeamLoading] = useState(false);
  const makeGamedaysCall = (paramsObj, cb, err) => {
    let loginCookie = getLoginCookie();
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Gamedays]
        ? (
            config.APIBASEPATH + config.WebConfig[config.APINames.Gamedays]
          ).replace("{{guid}}", loginCookie.GUID)
        : "",
      // endPoint: 'http://localhost:3000/gamedays.json',
      type: "GET",
      name: config.APINames.Gamedays,
      params: paramsObj,
    };

    getData(
      apiParams,
      (resp) => {
        let RetVal = resp?.Meta?.RetVal;
        if (RetVal === -100) {
          logOutCall(err);
        } else {
          setGamedays(resp.Data.Value.Gamedays);
          setCurrGameday(resp.Data.Value.CurrentGameday.CurrentGamedayId);
          if (cb) {
            cb(resp);
          }
        }
      },
      (error) => {
        let RetVal = error?.RetVal;
        if (RetVal === -100) {
          logOutCall();
        }
        if (error) {
          err(error);
        }
      }
    );
  };

  const getSelectedTeam = (paramsObj, cb) => {
    let loginCookie = getLoginCookie();
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.GetTeam]
        ? (
            config.APIBASEPATH + config.WebConfig[config.APINames.GetTeam]
          ).replace("{{guid}}", loginCookie.GUID)
        : "",
      type: "GET",
      name: config.APINames.GetTeam,
      params: paramsObj,
    };
    getData(
      apiParams,
      (resp) => {
        let RetVal = resp?.Meta?.RetVal;
        if (RetVal === -100) {
          logOutCall();
        } else {
          setIsTeamLoading(false);
          setSelectedTeam(resp.Data.Value);
          if (cb) {
            cb(resp);
          }
        }
      },
      (error) => {
        let RetVal = error?.RetVal;
        if (RetVal === -100) {
          logOutCall();
        }
      }
    );
  };

  return (
    <GamedaysContext.Provider
      value={{
        data: gamedays,
        selectedTeam,
        makeGamedaysCall,
        getSelectedTeam,
        getTeamCalled,
        setTeamCalled,
        isGamedaysCalled,
        setIsGamedaysCalled,
        setIsTeamLoading,
        setGamedays,
        setSelectedTeam,
        setCurrGameday,
        currGameday,
        isTeamLoading,
      }}
    >
      {props.children}
    </GamedaysContext.Provider>
  );
};

export const PlayerCardContextProvider = (props) => {
  let [playerDetail, setPlayerDetail] = useState(null);
  let [showPlayerCard, setVisibility] = useState(false);
  let [player, setPlayer] = useState({});
  let [playerIndex, setPlyInx] = useState(0);
  let [playerActions, setPlyActions] = useState(false);
  let [playerObjKey, setPlyObjKey] = useState(0);
  let [specificData, setSpecificData] = useState({});
  const showHidePlyrCard = (toggle) => {
    setVisibility(toggle ? toggle : !showPlayerCard);
  };
  const showHidePlyrCardVal = (value) => {
    setVisibility(false);
  };

  const getPlayerDetail = (paramsObj, cb) => {
    if (paramsObj.playerId) {
      let apiParams = {
        endPoint: config.WebConfig[config.APINames.playerCard]
          ? (
              config.FEEDBASEPATH +
              config.WebConfig[config.APINames.playerCardNew]
            )
              .replace("{{tourId}}", config.tourId)
              .replace("{{playerId}}", paramsObj.playerId)
          : "",
        type: "GET",
        name: config.APINames.playerCard,
        params: paramsObj,
      };

      getData(apiParams, (resp) => {
        setPlayerDetail(resp.Data.Value);
        if (cb) {
          cb(resp.Data.Value);
        }
      });
    } else {
      cb();
    }
  };
  return (
    <PlayerCardContext.Provider
      value={{
        playerDetail,
        getPlayerDetail,
        showPlayerCard,
        showHidePlyrCard,
        showHidePlyrCardVal,
        setPlayer,
        player,
        setPlyInx,
        playerIndex,
        setPlyActions,
        playerActions,
        playerObjKey,
        setPlyObjKey,
        specificData,
        setSpecificData,
      }}
    >
      {props.children}
    </PlayerCardContext.Provider>
  );
};

export const LiveScoringContextProvider = (props) => {
  let [scoring, setScoring] = useState(null);

  const getLiveScoring = (teamData, screenName, cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.liveMatch]
        ? config.FEEDBASEPATH + config.WebConfig[config.APINames.liveMatch]
        : config.FEEDBASEPATH + "scoring/live",
      type: "GET",
      name: config.APINames.liveMatch,
      params: {},
    };

    getData(
      apiParams,
      (resp) => {
        setScoring(resp.Data.Value);
      },
      (err) => {
        console.log(err);
      }
    );
  };

  return (
    <LiveScoringContext.Provider
      value={{
        scoring,
        getLiveScoring,
        setScoring,
      }}
    >
      {props.children}
    </LiveScoringContext.Provider>
  );
};

export const FetchGamerCardProvider = (props) => {
  let [userFetchData, setUserFetchData] = useState(null);

  const getFetchGamerCardData = (cb) => {
    let socialID = 0;
    let COOKIE_GM = config.COOKIE_GM;
    let parsedCookieGM = null;
    if (window.uefaGHComponent.getUserTokens().registered.user_id) {
      socialID = window.uefaGHComponent.getUserTokens().registered.user_id;
    }
    let params = {
      optType: config.WebConfig.optType,
      clientId: config.WebConfig.clientId,
      platformId: config.WebConfig.PLATFORM_ID_WEB,
      socialId: socialID,
      langCode: config.CURRENT_LANGUAGE,
    };

    let apiParams = {
      endPoint: config.WebConfig[config.APINames.fetchGamerCard]
        ? (
            config.APIBASEPATH +
            config.WebConfig[config.APINames.fetchGamerCard]
          ).replace("{{tour_id}}", config.tourId)
        : "",
      // endPoint: 'http://localhost:3000/live.json',
      type: "GET",
      name: config.APINames.fetchGamerCard,
      params: params,
    };

    getData(apiParams, (resp) => {
      setUserFetchData(resp);
      if (cb) {
        cb(resp);
      }
    });
  };

  return (
    <FetchGamerCardContext.Provider
      value={{
        getFetchGamerCardData: getFetchGamerCardData,
        userFetchData: userFetchData,
      }}
    >
      {props.children}
    </FetchGamerCardContext.Provider>
  );
};

export const FetchGeoLocationUrlProvider = (props) => {
  let [geolocationdata, setGeolocationData] = useState("");
  const getGeoLocationUrlData = (cb) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.geoLocation]
        ? config.APIBASEPATH + config.WebConfig[config.APINames.geoLocation]
        : config.APIBASEPATH + "geo",
      type: "GET",
      name: config.APINames.geoLocation,
      params: {},
    };
    getData(
      apiParams,
      (resp) => {
        setGeolocationData(resp?.Data?.Value);
        if (cb) {
          cb(resp);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  };

  return (
    <GeolocationUrlContext.Provider
      value={{
        getGeoLocationUrlData,
        geolocationdata,
      }}
    >
      {props.children}
    </GeolocationUrlContext.Provider>
  );
};

export const PlayersStatisticsProvider = (props) => {
  const [playerStatistics, setPlayerStatistics] = useState(null);
  const [isPlrStatsLoading, setPlrStatsLoading] = useState(false);

  const getPlayerStatistics = (paramObj, cb) => {
    setPlrStatsLoading(true);
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.Statitics]
        ? (config.FEEDBASEPATH + config.WebConfig[config.APINames.Statitics])
            .replace("{{tourId}}", config.tourId)
            .replace("{{lang}}", config.language)
        : (
            config.FEEDBASEPATH +
            "stats/playerstatitics/playerstatitics_{{tourId}}_{{lang}}"
          )
            .replace("{{tourId}}", config.tourId)
            .replace("{{lang}}", config.language),
      type: "GET",
      name: config.APINames.Statitics,
      params: paramObj,
    };
    getData(apiParams, (resp) => {
      setPlayerStatistics(resp.Data.Value);
      setPlrStatsLoading(false);
      if (cb) {
        cb(resp.Data.Value);
      }
    });
  };

  return (
    <PlayersStatisticsContext.Provider
      value={{
        data: playerStatistics,
        getPlayerStatistics,
        setPlrStatsLoading,
        isPlrStatsLoading,
      }}
    >
      {props.children}
    </PlayersStatisticsContext.Provider>
  );
};

export const GamerCardProvider = (props) => {
  const [cardData, setCardData] = useState(null);
  const [isGamerCardLoading, setGamerCardLoading] = useState(false);

  const getGameCard = (paramObj, cb, err) => {
    let cookie = getLoginCookie();
    setGamerCardLoading(true);
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.GamerCard]
        ? (
            config.APIBASEPATH + config.WebConfig[config.APINames.GamerCard]
          ).replace("{{guid}}", cookie ? cookie.GUID : 0)
        : config.APIBASEPATH +
          "cards/gamercard/{{guid}}".replace(
            "{{guid}}",
            cookie ? cookie.GUID : 0
          ),
      type: "GET",
      name: config.APINames.GamerCard,
      params: paramObj,
    };
    getData(
      apiParams,
      (resp) => {
        setCardData(resp.Data.Value);
        setGamerCardLoading(false);
        if (cb) {
          cb(resp.Data.Value);
        }
      },
      (error) => {
        setGamerCardLoading(false);
        if (err) {
          err(error);
        }
      }
    );
  };

  return (
    <GamerCardContext.Provider
      value={{
        data: cardData,
        getGameCard,
        setGamerCardLoading,
        isGamerCardLoading,
      }}
    >
      {props.children}
    </GamerCardContext.Provider>
  );
};
export const MixApiProvider = (props) => {
  const [mixApiData, setMixApiData] = useState(null);

  let cookie = getLoginCookie();

  const getMixApiData = (paramObj, cb, err) => {
    let apiParams = {
      endPoint: config.WebConfig[config.APINames.MixApi]
        ? (
            config.FEEDBASEPATH + config.WebConfig[config.APINames.MixApi]
          ).replace("{{tourId}}", config.tourId)
        : config.FEEDBASEPATH +
          "mixapi/version_{{guid}}".replace("{{guid}}", config.tourId),
      type: "GET",
      name: config.APINames.MixApi,
      params: paramObj,
    };
    getData(
      apiParams,
      (resp) => {
        setMixApiData(resp.Data.Value);
        if (cb) {
          cb(resp.Data.Value);
        }
      },
      (error) => {
        if (err) {
          err(error);
        }
      }
    );
  };

  return (
    <MixApiContext.Provider
      value={{
        data: mixApiData,
        getMixApiData,
      }}
    >
      {props.children}
    </MixApiContext.Provider>
  );
};
